<template>
  <div>
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" :title="dialogTitle">
      <!--      客户选择-->
      <CustomerSelect @selectRow="selectTheCustomer" :name="customerName"/>
      <!--      销售选择-->
      <el-dialog
          width="500px"
          :title="selectSaleTitle"
          :visible.sync="innerVisible"
          append-to-body>
        <el-form :model="selectData" :rules="rules" ref="form" status-icon size="small" label-width="80px"
                 :inline="false">
          <el-form-item :label="`客\u3000\u3000户`">
            {{ selectData.customer_name }}
          </el-form-item>
          <el-form-item label="客户集团" prop="combine_name">
            <el-select v-model="selectData.combine_name" filterable default-first-option remote
                       :remote-method="handelRemoteCombine"
                       class="el-input-c"
                       style="width: 100%"
                       size="mini" placeholder="请选择集团">
              <el-option v-for="item in combineOptions" :key="item.id" :label="item.name" :value="item.name"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="`销\u3000\u3000售`" prop="sale_id">
            <el-select class="el-input-c" v-model="selectData.sale_id" placeholder="请选择（可选）销售"
                       style="width: 100%"
                       @change="eventChangeSale"
                       filterable>
              <el-option v-for="item in saleOptions" :key="item.sale_id" :label="item.sale"
                         :value="item.sale_id">{{ item.sale }}
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售小组" prop="organization_id">
            <el-select class="el-input-c" v-model="selectData.organization_id" placeholder="请选择小组"
                       style="width: 100%"
                       filterable>
              <el-option v-for="item in organizationOptions" :key="item.id" :value="item.id" :label="item.label"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handelSure" :loading="loadingSure" :disabled="loadingSure">确认
            </el-button>
          </el-form-item>
        </el-form>

      </el-dialog>
    </el-dialog>

  </div>
</template>

<script>
import CustomerSelect from "@/components/customer/CustomerSelect";
import {getCustomerSaleOption} from "@/api/customers";
import {combineCustomerLikeQuery} from "@/api/combine";
import {options} from "@/api/organization";

const rules = {
  sale_id: [{required: true, message: "请选择销售", trigger: "change"}],
  organization_id: [{required: true, message: "请选择小组", trigger: "change"}],
};
export default {
  name: "CustomerSelectDialog",
  components: {CustomerSelect},
  props: {
    customerName: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      rules,
      dialogTitle: '选择客户与销售',
      selectData: {
        customer_id: null,
        customer_name: '',
        sale_id: null,
        sale: '',
        combine_id: null,
        combine_name: null,
        organization_id: null,
        organization_name: null
      },
      saleOptions: [], //销售下拉框
      combineOptions: [],
      organizationOptions: [],
      loadingSure: false,
      selectSaleTitle: '请选择销售',
      innerVisible: false,
    }
  },
  mounted() {
    this.getTeamList()
  },
  methods: {
    onOpen() {
      this.loadingSure = false
      this.innerVisible = false
    },
    onClose() {

    },
    close() {
      this.$emit('update:visible', false)
    },
    selectTheCustomer(row) {
      this.selectData.customer_name = row.name
      this.selectData.customer_id = row.id
      this.selectData.sale_id = null
      this.selectData.sale = null
      this.selectData.organization_id = null
      this.selectData.combine_name = row.combine && row.combine.name ? row.combine.name : null
      this.selectData.combine_id = row.combine && row.combine.id ? row.combine.id : null
      this.innerVisible = true
      this.loadingSure = false
      this.$nextTick(() => {
        this.loadSaleOption()
      })
    },
    async loadSaleOption() {
      // this.loadingSale = true
      await getCustomerSaleOption({customer_id: this.selectData.customer_id})
          .then((res) => {
            this.$nextTick(() => {
              this.saleOptions = res.model || []
            })
          })
    },
    handelSure() {
      const that = this
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.loadingSure = true
          const {sale_id, organization_id, combine_name} = that.selectData
          let saleObj = that.saleOptions.find(sale => sale.sale_id === sale_id)
          let organizationObj = that.organizationOptions.find(_ => _.id === organization_id)
          let combineObj = that.combineOptions.find(_ => _.name === combine_name)
          if (sale_id && !saleObj) {
            this.$message.error('销售数据异常，请联系管理员！');
            return;
          }
          if (organization_id && !organizationObj) {
            this.$message.error('小组数据异常，请联系管理员！');
            return;
          }

          this.selectData.sale = saleObj.sale
          this.selectData.organization_name = organizationObj.label
          this.selectData.combine_id = combineObj ? combineObj.name : null
          this.$emit('selected', this.selectData)
          this.innerVisible = false
        }
      });
    },
    eventChangeSale() {
      const that = this
      let saleObj = that.saleOptions.find(sale => sale.sale_id === that.selectData.sale_id)
      this.selectData.organization_id = saleObj.organization_id
    },
    async handelRemoteCombine(query) {
      const response = await combineCustomerLikeQuery({value: query})
      this.combineOptions = response.model || []
    },
    // 获取小组列表
    getTeamList() {
      options().then(res => {
        if (res.success) {
          this.organizationOptions = res.model;
          return false
        }
        this.$message.error(res.message);
      })
    },
  }
}
</script>

<style scoped>

</style>
